import styled from '@emotion/styled';
import { theme } from '@kindur/components';
import React from 'react';

const Grid = styled('div')`
  display: grid;
  grid-template-columns: repeat(12, 1fr);

  & > * {
    grid-column-end: span 6;
    grid-column-start: auto;

    ${theme.breakpoints.tabletDown} {
      grid-column-end: span 12;
    }
  }
`;

export default Grid;
